import { render, staticRenderFns } from "./ReportTournamentsComponent.vue?vue&type=template&id=c6445140&scoped=true"
import script from "./ReportTournamentsComponent.vue?vue&type=script&lang=js"
export * from "./ReportTournamentsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportTournamentsComponent.vue?vue&type=style&index=0&id=c6445140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6445140",
  null
  
)

export default component.exports